export default __webpack_public_path__ + "static/media/about-icon3.317015db.svg";